<template>
    <div id="contact-section" class="wrapper">
        <div class="contact">
            <h1>Contact</h1>
            <div class="open">
                <h2>Openingstijden</h2>
                <p>Maandag <br>Dinsdag<br>Woensdag<br>Donderdag <br>Vrijdag<br>Zaterdag<br>Zondag</p>
                <!-- Corona Openingstijden -->
<!--                <p>-->
<!--                    16:00 - 22:00<br>-->
<!--                    16:00 - 22:00<br>-->
<!--                    GESLOTEN<br>-->
<!--                    16:00 - 22:00<br>-->
<!--                    16:00 - 22:00<br>-->
<!--                    16:00 - 22:00<br>-->
<!--                    16:00 - 22:00-->
<!--                </p>-->
                <p>
                    14:00 - 22:00<br>
                    14:00 - 22:00<br>
                    GESLOTEN - mits feestdag(en)<br>
                    14:00 - 22:00<br>
                    14:00 - 22:00<br>
                    14:00 - 22:00<br>
                    14:00 - 22:00
                </p>
            </div>
            <div class="address">
                <h2>Little Asia</h2>
                <p>Kleiweg 87A<br>3051 GK <br>Rotterdam<br>
                <a href="tel:010 422 62 63"> 010 422 62 63</a>
                </p>
            </div>
            <div class="social">
                <h2>Social Media</h2>
                <p>Volg ons op social media</p>
                <a target="_blank" href="https://www.facebook.com/Restaurant-little-asia-1475431362750932/">
                    <i class="fab fa-facebook"></i>
                </a>
                <a target="_blank" href="https://www.instagram.com/littleasia_rotterdam/">
                    <i class="fab fa-instagram"></i>
                </a>
            </div>
            <div class="footer">
                <p>&copy;{{this.currentYear}} Copyright – Restaurant Little Asia</p>
                <p>Website made by – <a target="_blank" href="https://year3000.nl/">Year 3000 ❤️</a></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentYear: new Date().getFullYear()
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        // Bug fix IOS footer displaying on top of intro
        handleScroll() {
            let element = document.getElementById('contact-section')
            if(window.pageYOffset > 500) {
                element.style.display = 'block'
            }
            else {
                element.style.display = 'none'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .wrapper {
        position: fixed;
        width: 100%;
        bottom: 0px;
        z-index: -2;
        color: rgb(255, 255, 255);
        background: #000;
        .contact {
            width: 75vw;
            margin-left: 14vw;
            padding-top: 1rem;
            height: 400px;
            h1{
                font-size: 3em;
            }
            h2 {
                color: #ecf0f1;
            }
            .open{
                float: left;
                padding: 0rem 2rem 1.5rem 0;
                p{
                    float: left;
                    margin-top: 0;
                    margin-right: 1em;
                }
            }
            .address{
                float: left;
                padding: 0rem 1rem 1.5rem 10rem;
                p{
                    font-size: 1.3em;
                }
                a{
                    color: white;
                }

            }
            .social{
                float: left;
                padding: 0rem 1rem 1.5rem 10rem;
                a {
                    color: #ffffff;
                    margin-right: 1em;
                    &:visited {
                        color: #ffffff;
                    }
                    i {
                        font-size: 2rem;
                    }
                }
                p{
                    font-size: .8em;
                }
            }
            .footer {
                float: left;
                width: 100%;
                display: block;
                font-size: .9em;
                a {
                    color: #ffffff;
                    &:visited {
                        color: #ffffff;
                    }
                }
            }
        }
    }
@media screen and (max-width: 600px) {
    .wrapper{
        margin-top: 0;
        padding-top: 0;
        padding-bottom: 0;
        .contact {
            width: 98%;
            margin-left: 2vw;
            height: 470px;

            h1{
                margin: 0 0 0 1rem;
                font-size: 2.5em;
            }
            .address{
                float:left;
                padding: 0rem 1rem 0rem 1rem;
                width: 40%;
                p{
                    font-size: 1.1em;
                }
            }
            .open{
                float: left;
                padding: 0rem 1rem 0rem 1rem;
                width: 100%;
                p{
                    float: left;
                    margin-top: 0;
                    font-size: 0.9em;
                }
            }
            .social{
                float:left;
                width: 50%;
                padding: 0;
            }
            .footer{
                margin: 15px;
                p{
                    margin:0;
                }
            }
        }
    }
}
</style>
